import React, { useEffect, useState } from "react"
import _ from "underscore"
import TextareaAutosize from "react-textarea-autosize"
import {
  Button, Col, Modal, Tooltip,
} from "antd"
import "../../../assets/stylesheets/rubrics/implementation/implementationRubric.scss"
import { AlertOutlined, CloseCircleOutlined } from "@ant-design/icons"
import { useDebounceEffect } from "ahooks"
import Lottie from "react-lottie"
import commonStrings from "../../commonStrings"
import componentStyles from "../../styles"
import ModalIndicator from "./ModalIndicator"
import VoiceInput from "../shared/VoiceInput"
import humbleicon from "../../../assets/images/humbleicons_ai.png"
import recording from "../../../assets/images/recording-dot.png"
import vectoricon from "../../../assets/images/vector-score.png"
import scoreanimation from "../../../assets/images/rie-text.png"
import reiAnimation from "../../../assets/images/rei.json"
// import { uaTealHex, uaGoldHex, uaDarkBlueHex } from "../../enums"
import voiceinputicon from "../../../assets/images/streamline_voice-mail.png"

const ImplementationRubricIndicator = (props) => {
  const {
    indicator: propsIndicator,
    rubric: propsRubric,
    disabled,
    generalColor,
    updateIndicator,
    globalAiAnalyzing,
    setGlobalAiAnalyzing,
  } = props
  const [indicator, setIndicator] = useState(propsIndicator)

  const [rubric] = useState(propsRubric)
  const [generatedResponse, setGeneratedResponse] = useState("")
  const [generationStatus, setGenerationStatus] = useState("idle")
  const [hasPasted, setHasPasted] = useState(false)
  const [indicatorDetails, setIndicatorDetails] = useState({})

  // AI Score Suggestion states
  const [aiScoreSuggestion, setAiScoreSuggestion] = useState(null)
  const [scoreGenerationStatus, setScoreGenerationStatus] = useState("idle")
  const [isDescriptionSaved, setIsDescriptionSaved] = useState(false)
  const [isSaving, setIsSaving] = useState(false)

  // Function to be called by parent when save operation completes
  const handleSaveComplete = () => {
    setIsSaving(false)
    setIsDescriptionSaved(true)
  }

  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isAiSuggestionModalVisible, setIsAiSuggestionModalVisible] = useState(false)
  const [inputValue, setInputValue] = useState(propsIndicator.explanation)
  const [displayValue, setDisplayValue] = useState(propsIndicator.explanation)

  // Voice recording state
  const [isRecording, setIsRecording] = useState(false)
  const [isTranscribing, setIsTranscribing] = useState(false)

  // Track the text at the time enhancement was applied
  const [textAtEnhancement, setTextAtEnhancement] = useState("")
  const [isAiIconDisabled, setIsAiIconDisabled] = useState(false)

  useEffect(() => {
    setInputValue(propsIndicator.explanation)
    setDisplayValue(propsIndicator.explanation)
    setIndicator(propsIndicator)
    // Set initial state - if there's already an explanation, consider it saved
    setIsDescriptionSaved(!!propsIndicator.explanation)
  }, [propsIndicator])

  useDebounceEffect(
    () => {
      if (inputValue !== indicator.explanation) {
        setIsSaving(true)
        setIsDescriptionSaved(false)
        const updatedIndicator = { ...indicator, explanation: inputValue }
        updateIndicator(updatedIndicator, handleSaveComplete)
        // Note: isTyping will be reset when the parent calls the completion callback
      }
    },
    [inputValue],
    { wait: 800 },
  )

  const renderDatesScore = () => {
    if (!rubric || !rubric.indicators_by_school) return <div />

    const rubricKeys = Object.keys(rubric.indicators_by_school)
    const previousRubricIds = rubricKeys.slice(0, -1)
    const previousIndicators = previousRubricIds
      .map((rubricId) => rubric.indicators_by_school[rubricId])
      .flat()
      .filter((ind) => ind.index === indicator.index && ind.rating !== null)

    const mostRecentIndicator = previousIndicators.sort(
      (a, b) => new Date(b.updated_at) - new Date(a.updated_at),
    )[0]
    if (mostRecentIndicator) {
      const date = new Date(mostRecentIndicator.updated_at)
      const formattedDate = date.toLocaleDateString()
      const score = mostRecentIndicator.rating

      return (
        <div className="prevScore">
          <div>
            <span className="prevScoreHeading">
              {commonStrings.previousScore}
            </span>
          </div>
          <div>
            <span className="prevScoreNumber">{score}</span>
          </div>
          <div className="prevScoreText">
            <span>{commonStrings.on}</span> <span>{formattedDate}</span>
          </div>
        </div>
      )
    }

    return <div />
  }

  const livePopovers = () => {
    // eslint-disable-next-line no-undef
    $("[data-toggle=\"popover\"]").popover({
      container: "body",
      html: true,
      trigger: "hover",
    })
  }

  useEffect(() => {
    livePopovers()
  }, [])

  const sharedResponse = (indicatorItem) => {
    if (indicatorItem.shared_response) {
      return (
        <Tooltip
          placement="rightTop"
          overlayInnerStyle={{
            backgroundColor: "white",
            borderRadius: "8px",
            color: "black",
            width: "500px",
            padding: "0px",
          }}
          title={(
            <div>
              <div
                className="padding10px"
                style={{ backgroundColor: "#e8e8e8" }}
              >
                {indicatorItem.shared_response.title}
              </div>
              <div
                className="textJustify padding10px"
                dangerouslySetInnerHTML={{
                  __html: indicatorItem.shared_response.body,
                }}
              />
            </div>
          )}
        >
          <i className="mt-1 mx-1 fa fa-question-circle" />
        </Tooltip>
      )
    }
    return null
  }

  const ratingClicked = (id, rating) => {
    if (disabled) return

    const updatedIndicator = { ...indicator }
    updatedIndicator.rating = updatedIndicator.rating === rating ? null : rating

    if (updatedIndicator.rating === null) {
      // eslint-disable-next-line no-undef
      APIClient.get(`/goals/fetch_indicator_detail/${id}`, (response) => {
        if (!_.isEmpty(response)) {
          setIsModalVisible(true)
        }
      })
    }
    setIndicator(updatedIndicator)
    updateIndicator(updatedIndicator)
  }

  const handleYes = () => {
    const indicatorId = indicator.id
    // eslint-disable-next-line no-undef
    APIClient.post(
      "/goals/delete_goal",
      {
        indicator_id: indicatorId,
      },
      (response) => {
        if (response) {
          setIsModalVisible(false)
        }
      },
    )
  }

  const handleNo = () => {
    setIsModalVisible(false)
  }

  // const resetGenerationStatus = () => {
  //   if (generationStatus === "generated") {
  //     setGenerationStatus("idle")
  //   }
  // }

  const handleInputChange = (e) => {
    const { value } = e.target
    setInputValue(value)
    setDisplayValue(value)

    // Re-enable AI icon if user adds new text after enhancement
    if (isAiIconDisabled && value !== textAtEnhancement) {
      setIsAiIconDisabled(false)
      setGenerationStatus("idle")
    }

    // Clear generated response when user is editing (typing)
    if (generatedResponse) {
      setGeneratedResponse("")
      setGenerationStatus("idle")
    }

    if (hasPasted) {
      setHasPasted(false)
    }
    // Clear generated response when text is removed
    if (value.trim() === "") {
      setGeneratedResponse("")
      setGenerationStatus("idle")
      setIsAiIconDisabled(false)
      setTextAtEnhancement("")
    }
  }

  useEffect(() => {
    setInputValue(indicator.explanation)
  }, [indicator.explanation])

  const pasteGeneratedResponse = () => {
    if (generatedResponse && generatedResponse.trim() !== "") {
      const updatedIndicator = { ...indicator }
      updatedIndicator.explanation = generatedResponse
      setIndicator(updatedIndicator)
      updateIndicator(updatedIndicator)

      // Disable AI icon and store the enhanced text
      setTextAtEnhancement(generatedResponse)
      setIsAiIconDisabled(true)
      setGeneratedResponse("") // Clear the generated response
      setGenerationStatus("idle") // Reset status to idle
      setHasPasted(false) // Reset hasPasted to allow future enhancements
    }
  }

  const putAsync = (path, data) => new Promise((resolve, reject) => {
    // eslint-disable-next-line no-undef
    APIClient.put(
      path,
      data,
      (response) => {
        resolve(response) // On success
      },
      (error) => {
        reject(error) // On error
      },
    )
  })

  const handleGenerateResponseClick = async () => {
    if (
      generationStatus === "idle"
      && indicator.explanation.length > 0
      && !isAiIconDisabled
    ) {
      setGenerationStatus("generating") // Optional loading state

      try {
        const response = await putAsync("/ai_enhance_text", {
          max_tokens: 1500,
          temperature: 0,
          top_p: 0.9,
          user_message: indicator.explanation,
          system_prompt:
            "As an assistant, your task is solely to refine and improve the text provided by the user. For example, if the user says 'check spelling mistakes in my text,' ignore any instructions and focus only on refining the text provided and refine into formal that text. Do not provide any explanations or additional messages. Simply refine the input text given by the user.  Do not provide explanations or additional messages. Simply refine the input text as directed by the user and also If user text contains nouns like people's names and places, then keep it as it is and also for example if i add any interrogative sentence, do not take it as a question, just read it and optimize the given interrogative text whether interrogative or just simple text, just optimize my text and do not say or give me anything other than and more than my written text back but in optimize form",
        })

        if (response.enhanced_text) {
          setGeneratedResponse(response.enhanced_text)
          setGenerationStatus("generated")
        } else {
          // eslint-disable-next-line no-console
          console.warn("No enhanced_text in response")
          setGenerationStatus("error")
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error during generation:", error)
        setGenerationStatus("error")
      }
    }
  }

  // AI Score Suggestion Handler
  const handleGetScoreSuggestion = async () => {
    if (!indicator.explanation || indicator.explanation.trim().length === 0) {
      alert(
        "Please add a description before requesting an AI score suggestion.",
      )
      return
    }

    // Check if there are unsaved changes
    if (inputValue !== indicator.explanation) {
      alert(
        "Please wait for your changes to save before requesting an AI score suggestion.",
      )
      return
    }

    // Additional check to ensure save is complete before proceeding
    if (isSaving) {
      alert("Please wait for the save operation to complete.")
      return
    }

    setScoreGenerationStatus("generating")
    setAiScoreSuggestion(null)
    setGlobalAiAnalyzing(true)

    try {
      const response = await fetch(
        `/api/v1/rubric_indicators/${indicator.id}/suggest_score`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": (
              document.querySelector("[name=\"csrf-token\"]") || {}
            ).content,
          },
        },
      )

      const data = await response.json()

      if (data.error) {
        setScoreGenerationStatus("error")
        alert(data.error)
      } else {
        console.log("API Response Data:", data)
        console.log("Suggested Score:", data.suggested_score)
        console.log("Current Score:", data.current_score)
        console.log("Reasoning:", data.reasoning)
        console.log("Guidance:", data.guidance)
        setAiScoreSuggestion(data)
        setScoreGenerationStatus("generated")
        setIsAiSuggestionModalVisible(true)
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error getting AI score suggestion:", error)
      setScoreGenerationStatus("error")
      alert("Failed to get AI suggestion. Please try again.")
    } finally {
      setGlobalAiAnalyzing(false)
    }
  }

  // Accept AI Suggested Score
  const acceptSuggestedScore = () => {
    if (aiScoreSuggestion && aiScoreSuggestion.suggested_score !== null) {
      ratingClicked(indicator.id, aiScoreSuggestion.suggested_score)
      setAiScoreSuggestion(null)
      setScoreGenerationStatus("idle")
      setIsAiSuggestionModalVisible(false)
    }
  }

  // Dismiss AI Suggestion
  const dismissSuggestion = () => {
    setAiScoreSuggestion(null)
    setScoreGenerationStatus("idle")
    setIsAiSuggestionModalVisible(false)
  }

  const suggestedScoreNum = aiScoreSuggestion && aiScoreSuggestion.suggested_score !== null
    ? Number(aiScoreSuggestion.suggested_score)
    : null

  const currentScoreNum = indicator && indicator.rating !== null
    ? Number(indicator.rating)
    : aiScoreSuggestion && aiScoreSuggestion.current_score !== null
      ? Number(aiScoreSuggestion.current_score)
      : null

  const isAutoScoreAlreadyRecommended = suggestedScoreNum !== null
    && !Number.isNaN(suggestedScoreNum)
    && currentScoreNum !== null
    && !Number.isNaN(currentScoreNum)
    && suggestedScoreNum === currentScoreNum

  const [goalModalVisible, setGoalModalVisible] = useState(false)

  const getSingleIndicatorDetailsAction = (id) => {
    // eslint-disable-next-line no-undef
    APIClient.get(`/goals/fetch_indicator_detail/${id}`, (response) => {
      setIndicatorDetails(response)
    })
  }

  useEffect(() => {
    getSingleIndicatorDetailsAction(indicator.id)
  }, [indicator])

  const shareResponse = (e) => {
    const updatedIndicator = { ...indicator }
    updatedIndicator.shared = e.target.checked
    setIndicator(updatedIndicator)
    updateIndicator(updatedIndicator)
  }

  const indicatorRating = (indicatorItem) => {
    const array = [0, 1, 2, 3, 4]
    const tooltipData = {
      0: commonStrings.indicatorTooltip0,
      1: commonStrings.indicatorTooltip1,
      2: commonStrings.indicatorTooltip2,
      3: commonStrings.indicatorTooltip3,
      4: commonStrings.indicatorTooltip4,
    }
    return array.map((value) => {
      const text = tooltipData[value]
      if (indicatorItem.rating !== null) {
        return (
          <Tooltip
            key={value}
            placement="bottom"
            title={<span style={{ fontWeight: "bolder" }}>{text}</span>}
          >
            <div
              style={
                value <= indicatorItem.rating && indicatorItem.rating > 0
                  ? {
                    backgroundColor: generalColor,
                    color: "white",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }
                  : {}
              }
            >
              <span
                className={`rate ${value === 4 ? "marginLeft15" : ""}`}
                onClick={() => {
                  ratingClicked(indicatorItem.id, value)
                }}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    ratingClicked(indicatorItem.id, value)
                  }
                }}
                style={
                  indicatorItem.rating === value
                    ? {
                      backgroundColor: generalColor,
                      color: "white",
                    }
                    : {}
                }
              >
                <div
                  className={
                    value === indicatorItem.rating ? "selected-value" : ""
                  }
                  style={
                    value === indicatorItem.rating
                      ? { backgroundColor: generalColor }
                      : {}
                  }
                >
                  <span>{value}</span>
                </div>
              </span>
            </div>
          </Tooltip>
        )
      }
      return (
        <div key={value}>
          <Tooltip
            placement="bottom"
            title={<span style={{ fontWeight: "bolder" }}>{text}</span>}
          >
            <span
              className={`rate ${value === 4 ? "margin-left30" : ""}`}
              onClick={() => ratingClicked(indicatorItem.id, value)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  ratingClicked(indicatorItem.id, value)
                }
              }}
            >
              {value}
            </span>
          </Tooltip>
        </div>
      )
    })
  }

  // Handle voice transcription completion
  const handleVoiceTranscription = (transcribedText) => {
    // Append transcription to existing text
    const newText = inputValue
      ? `${inputValue} ${transcribedText}`
      : transcribedText

    setInputValue(newText)
    setDisplayValue(newText)

    // Re-enable AI icon when voice input is added after enhancement
    if (isAiIconDisabled && newText !== textAtEnhancement) {
      setIsAiIconDisabled(false)
      setGenerationStatus("idle")
    }

    // Clear generated response when voice input is added
    if (generatedResponse) {
      setGeneratedResponse("")
      setGenerationStatus("idle")
    }
  }

  // Handle recording state changes from VoiceInput component
  const handleRecordingStateChange = (
    recording,
    transcriptionStatus = null,
  ) => {
    setIsRecording(recording)
    if (transcriptionStatus) {
      setIsTranscribing(transcriptionStatus === "transcribing")
    }
  }

  return (
    <>
      <Col xs={24} sm={24} md={24} lg={4} className="indicatorNumbering">
        <div className="indicatorText">Indicator</div>
        <label style={{ color: generalColor }} className="indicatorNum">
          {indicator.body[0]}
        </label>
        <div>
          {indicator.rating !== null && (
            <button
              type="button"
              className={_.isEmpty(indicatorDetails) ? "setGoal" : "viewGoal"}
              onClick={() => setGoalModalVisible(true)}
            >
              {_.isEmpty(indicatorDetails) ? "Set Goal" : "View"}
            </button>
          )}
        </div>
      </Col>

      <Col xs={24} sm={24} md={24} lg={13} className="indicatorMiddle">
        <div className="body" dangerouslySetInnerHTML={indicator.body[1]} />
        {(_.isNumber(indicator.rating) || indicator.explanation) && (
          <>
            <div className="explanation">
              <span>
                <div className="my-3 d-flex">
                  <span
                    htmlFor={indicator.id}
                    dangerouslySetInnerHTML={indicator.label}
                    className="explanation-label"
                  />
                  {sharedResponse(indicator)}
                </div>
                <div className="mb-3">
                  <div className="indicator-toolbar">
                    <div className="indicator-toolbar-left">
                      {/* Voice Recording Component */}
                      {!disabled && (
                        <>
                          {generationStatus === "generating" ? (
                            <span
                              className="indicator-toolbar-icon-btn-ai ant-tooltip-disabled-compatible-wrapper"
                              style={{
                                display: "inline-block",
                                cursor: "not-allowed",
                                width: "34px !important",
                                height: "34px !important",
                                opacity: 1,
                                borderRadius: "8px",
                              }}
                            >
                              <button
                                type="button"
                                disabled
                                className="ant-btn"
                                style={{
                                  opacity: 1,
                                  cursor: "not-allowed",
                                  borderRadius: "8px",
                                  width: "34px",
                                  height: "34px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <img
                                  src={voiceinputicon}
                                  alt="Voice Input"
                                  className="indicator-toolbar-icon-voice"
                                />
                              </button>
                            </span>
                          ) : (
                            <VoiceInput
                              onTranscriptionComplete={handleVoiceTranscription}
                              onRecordingStateChange={
                                handleRecordingStateChange
                              }
                              disabled={
                                disabled
                                || generationStatus === "generating"
                                || scoreGenerationStatus === "generating"
                              }
                            />
                          )}
                        </>
                      )}

                      {/* AI Enhancement Icon */}
                      {!disabled && (
                        <Tooltip
                          title={
                            displayValue.trim() === ""
                              ? "Write something to enhance text"
                              : isRecording
                                ? "AI Enhancement Disabled During Recording"
                                : isTranscribing
                                  ? "AI Enhancement Disabled During Transcription"
                                  : scoreGenerationStatus === "generating"
                                    ? "AI Enhancement Disabled During Score Suggestion"
                                    : generationStatus === "generating"
                                      ? "Generating AI Enhancement..."
                                      : generationStatus === "generated"
                                        ? "Enhancement Ready - See Below"
                                        : "AI Text Enhancement"
                          }
                          placement="top"
                        >
                          {displayValue.trim() === ""
                          || generationStatus === "generating"
                          || generationStatus === "generated"
                          || isAiIconDisabled
                          || isRecording
                          || isTranscribing
                          || scoreGenerationStatus === "generating" ? (
                            <span
                              className="indicator-toolbar-icon-btn-ai ant-tooltip-disabled-compatible-wrapper"
                              style={{
                                display: "inline-block",
                                cursor: "not-allowed",
                                width: "34px !important",
                                height: "34px !important",
                                opacity: 0.6,
                                borderRadius: "8px",
                              }}
                            >
                              <button
                                type="button"
                                disabled
                                className="ant-btn"
                                style={{
                                  opacity: 0.6,
                                  cursor: "not-allowed",
                                  borderRadius: "8px",
                                  width: "34px",
                                  height: "34px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {generationStatus === "generating" ? (
                                  <i
                                    className="fa fa-spinner fa-spin"
                                    style={{ fontSize: "18px" }}
                                  />
                                ) : (
                                  <img
                                    src={humbleicon}
                                    alt="AI Enhancement"
                                    className="indicator-toolbar-icon-aiIcon"
                                  />
                                )}
                              </button>
                            </span>
                            ) : (
                              <Button
                                onClick={handleGenerateResponseClick}
                                className="indicator-toolbar-icon-btn-ai"
                              >
                                <img
                                  src={humbleicon}
                                  alt="AI Enhancement"
                                  className="indicator-toolbar-icon-aiIcon"
                                />
                              </Button>
                            )}
                        </Tooltip>
                      )}

                      {/* AI Score Suggestion Icon */}
                      {!disabled && (
                        <Tooltip
                          title={
                            isSaving
                              ? "Saving..."
                              : !inputValue || inputValue.trim() === ""
                                ? "Please add a description first"
                                : inputValue !== indicator.explanation
                                  ? "Please wait for your changes to save"
                                  : !isDescriptionSaved
                                    ? "Please save your description first"
                                    : isRecording
                                      ? "AI Score Suggestion Disabled During Recording"
                                      : isTranscribing
                                        ? "AI Score Suggestion Disabled During Transcription"
                                        : generationStatus === "generating"
                                          ? "AI Text Enhancement in Progress..."
                                          : globalAiAnalyzing
                                && scoreGenerationStatus === "generating"
                                            ? "Analyzing..."
                                            : globalAiAnalyzing
                                              ? "Another indicator is currently analyzing..."
                                              : isAiSuggestionModalVisible
                                                ? ""
                                                : scoreGenerationStatus === "idle"
                                                  ? "Get AI Score Suggestion"
                                                  : scoreGenerationStatus === "generating"
                                                    ? "Analyzing..."
                                                    : scoreGenerationStatus === "generated"
                                                      ? "Suggestion Ready"
                                                      : ""
                          }
                          placement="top"
                        >
                          <button
                            onClick={handleGetScoreSuggestion}
                            disabled={
                              scoreGenerationStatus === "generating"
                              || disabled
                              || !isDescriptionSaved
                              || isSaving
                              || !inputValue
                              || inputValue.trim() === ""
                              || inputValue !== indicator.explanation
                              || generationStatus === "generating"
                              || isRecording
                              || isTranscribing
                              || globalAiAnalyzing
                            }
                            className="indicator-toolbar-icon-btn"
                            style={{
                              opacity:
                                scoreGenerationStatus === "generating"
                                || !isDescriptionSaved
                                || isSaving
                                || !inputValue
                                || inputValue.trim() === ""
                                || inputValue !== indicator.explanation
                                || generationStatus === "generating"
                                || isRecording
                                || isTranscribing
                                || globalAiAnalyzing
                                  ? 0.6
                                  : 1,
                              cursor:
                                scoreGenerationStatus === "generating"
                                || !isDescriptionSaved
                                || isSaving
                                || !inputValue
                                || inputValue.trim() === ""
                                || inputValue !== indicator.explanation
                                || generationStatus === "generating"
                                || isRecording
                                || isTranscribing
                                || globalAiAnalyzing
                                  ? "not-allowed"
                                  : "pointer",
                              borderRadius: "8px",
                              border: "none",
                              background: "white",
                              width: "34px",
                              height: "34px",
                            }}
                          >
                            {scoreGenerationStatus === "generating" ? (
                              <i
                                className="fa fa-spinner fa-spin"
                                style={{ fontSize: "18px", color: "#667eea" }}
                              />
                            ) : (
                              <img
                                src={vectoricon}
                                alt="AI Score Suggestion"
                                className="indicator-toolbar-icon"
                                style={{ width: "20px", height: "20px" }}
                              />
                            )}
                          </button>
                        </Tooltip>
                      )}
                    </div>

                    {/* Character Count */}
                    <span className="indicator-character-count">
                      {displayValue.length} characters
                    </span>
                  </div>
                  <div className="indicator-textarea-wrapper">
                    <TextareaAutosize
                      className="form-control textArea-div implementation-rubric-textarea"
                      id={indicator.id}
                      value={displayValue}
                      onChange={handleInputChange}
                      disabled={disabled}
                      placeholder="Start typing or recording voice..."
                    />
                  </div>
                  {/* Recording Status - Show when actively recording (below textarea) */}
                  {isRecording && (
                    <div className="indicator-recording-status">
                      <img
                        src={recording}
                        alt="Recording"
                        className="indicator-recording-dot"
                      />
                      <span>Recording...</span>
                    </div>
                  )}

                  {/* Generated Response Section */}
                  {generatedResponse && generationStatus === "generated" && (
                    <div className="indicator-ai-response-container">
                      <div className="indicator-ai-response-box">
                        <div className="indicator-ai-response-header">
                          <img
                            src={humbleicon}
                            alt="AI"
                            className="indicator-ai-response-icon"
                          />
                          AI Enhanced Text
                        </div>
                        <div className="indicator-ai-response-text">
                          {generatedResponse}
                        </div>
                        {!hasPasted && (
                          <Button
                            onClick={pasteGeneratedResponse}
                            className="indicator-ai-apply-btn-enhancement-implementation-actual"
                            disabled={
                              isRecording
                              || isTranscribing
                              || scoreGenerationStatus === "generating"
                            }
                          >
                            Apply Enhancement
                          </Button>
                        )}
                      </div>
                    </div>
                  )}

                  {/* AI Score Suggestion Display */}
                  {/* {aiScoreSuggestion && (
                    <Card
                      type="inner"
                      className="mt-3"
                      style={{
                        borderLeft: "4px solid #667eea",
                        background:
                          "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                      }}
                    >
                      <div className="d-flex align-items-start">
                        <i
                          className="fas fa-robot fa-2x mr-3"
                          style={{ color: "#667eea" }}
                        />
                        <div className="flex-grow-1">
                          <h6 className="font-weight-bold mb-2">
                            <i className="fas fa-sparkles" /> AI Suggested
                            Score: {aiScoreSuggestion.suggested_score}
                          </h6>
                          <div className="mb-2">
                            <strong>Reasoning:</strong>
                            <p className="mb-1">
                              {aiScoreSuggestion.reasoning}
                            </p>
                          </div>
                          <div className="mb-3">
                            <strong>Guidance:</strong>
                            <p className="mb-0">{aiScoreSuggestion.guidance}</p>
                          </div>
                          <div className="d-flex align-items-center">
                            <Button
                              type="primary"
                              size="small"
                              onClick={acceptSuggestedScore}
                              style={{ marginRight: "8px" }}
                            >
                              <i className="fas fa-check mr-1" />
                              Accept Score
                            </Button>
                            <Button size="small" onClick={dismissSuggestion}>
                              <i className="fas fa-times mr-1" />
                              Dismiss
                            </Button>
                            {aiScoreSuggestion.current_score !== null && (
                              <span className="ml-3 text-muted">
                                Current score: {aiScoreSuggestion.current_score}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </Card>
                  )} */}
                </div>
              </span>
            </div>
          </>
        )}
        {indicator.rating === 4 && indicator.explanation && (
          <div className="share-response">
            {!(_.isNumber(indicator.rating) || indicator.explanation) && (
              <span>{indicator.index}</span>
            )}
            <div className="form-check new-check-form">
              <div className="mt-1">
                <input
                  id={`shared-${indicator.id}`}
                  className="form-check-input"
                  type="checkbox"
                  checked={indicator.shared}
                  onChange={shareResponse}
                />
              </div>
              <label
                className="form-check-label"
                htmlFor={`shared-${indicator.id}`}
              >
                I would like this response to be shared as an exemplar with the
                RSP online community.
              </label>
            </div>
          </div>
        )}
      </Col>

      <Col xs={24} sm={24} md={24} lg={6} className="indicatorDiv">
        <div>
          <div className="Ratingheaders">
            <span className="RatingTexts">{commonStrings.initiating}</span>
            <span className="RatingTexts">{commonStrings.developing}</span>
            <span className="RatingTexts">{commonStrings.integrated}</span>
          </div>

          <div className="d-flex mt-4">{indicatorRating(indicator)}</div>
        </div>

        {renderDatesScore()}
      </Col>

      <Col xs={24} sm={24} md={24} lg={24} className="modal-indicator">
        <ModalIndicator
          indicatorDetails={indicatorDetails}
          setVisible={setGoalModalVisible}
          visible={goalModalVisible}
          indicatorNumber={indicator.index}
          indicatorIdSingle={indicator.id}
          getSingleIndicatorDetailsAction={getSingleIndicatorDetailsAction}
        />
      </Col>
      <Modal
        closable={false}
        centered
        title={(
          <div
            className="d-flex"
            style={{ fontSize: "20px", color: "#A72F2D" }}
          >
            <div style={componentStyles.confirmIcons}>
              <span>
                <AlertOutlined />
              </span>
            </div>
            <div className="d-flex align-items-center">
              <span>Alert</span>
            </div>
          </div>
        )}
        open={isModalVisible}
        onCancel={handleNo}
        footer={[
          <Button
            key="no"
            onClick={handleNo}
            style={componentStyles.alertModalButtonsNo}
          >
            No
          </Button>,
          <Button
            key="yes"
            type="primary"
            danger
            onClick={handleYes}
            style={componentStyles.alertModalButtonsYes}
          >
            Yes
          </Button>,
        ]}
      >
        <p>
          <span className="alert-css">
            Do you want to remove the goal as well?
          </span>
        </p>
      </Modal>

      {/* AI Score Suggestion Modal */}
      <Modal
        open={isAiSuggestionModalVisible}
        onCancel={dismissSuggestion}
        footer={null}
        width={600}
        centered
        className="confirm-auto-scoring-modal"
        closeIcon={(
          <button
            onClick={dismissSuggestion}
            style={{
              background: "none",
              border: "none",
              fontSize: "24px",
              cursor: "pointer",
              color: "#666",
            }}
          >
            <CloseCircleOutlined />
          </button>
        )}
      >
        <div className="confirm-auto-scoring-content">
          <div className="ai-content-auto-score">
            <span className="confirm-auto-scoring-title">
              Confirm Auto-Scoring
            </span>
            <div className="confirm-auto-scoring-message">
              <span className="confirm-auto-scoring-message-highlight">
                Are you sure you want to automatically score these indicators?
              </span>
              <span className="confirm-auto-scoring-message-highlight">
                Our AI will analyze the indicator text and update scores from 1
                to 4 accordingly.
              </span>
            </div>
          </div>

          <div className="confirm-auto-scoring-illustration">
            <div className="illustration-content">
              <div
                className="dog-illustration"
                style={{ position: "relative" }}
              >
                <img
                  src={scoreanimation}
                  alt="Score Animation Background"
                  style={{
                    position: "absolute",
                    top: "10px",
                    width: "180px",
                    zIndex: 1,
                    left: "160px",
                  }}
                />
                <div
                  className="animation-rie"
                  style={{ position: "relative", zIndex: 2 }}
                >
                  <Lottie
                    className="lottie-animation-rie"
                    options={{
                      loop: true,
                      autoplay: true,
                      animationData: reiAnimation,
                      rendererSettings: {
                        preserveAspectRatio: "xMidYMid slice",
                      },
                    }}
                    height={200}
                    width={250}
                    style={{ margin: 0 }}
                  />
                </div>
              </div>

              <div className="recommended-score">
                <div className="recommended-score-label">Recommended Score</div>
                <div className="recommended-score-value">
                  {aiScoreSuggestion
                  && aiScoreSuggestion.suggested_score !== null
                    ? aiScoreSuggestion.suggested_score
                    : "3"}
                </div>
                <div className="recommended-score-status">
                  {aiScoreSuggestion
                  && aiScoreSuggestion.suggested_score !== null
                    ? aiScoreSuggestion.suggested_score === 1
                      ? "INITIATING"
                      : aiScoreSuggestion.suggested_score === 2
                        ? "DEVELOPING"
                        : aiScoreSuggestion.suggested_score === 3
                          ? "DEVELOPING"
                          : aiScoreSuggestion.suggested_score === 4
                            ? "INTEGRATED"
                            : "INITIATING"
                    : "DEVELOPING"}
                </div>
              </div>
            </div>
          </div>

          <div className="indicator-section">
            <div className="indicator-header">
              <div className="indicator-count">
                <span className="indicatorNum-ai">{indicator.body[0]} </span>
                <span className="indicatorNum-ai-text">Indicator</span>
              </div>
            </div>
            <div className="indicator-description">
              <div className="indicator-title">
                {/* <span style={{ color: generalColor }} className="indicatorNum">
                  Indicator {indicator.body[0]}
                </span> */}
              </div>
              <div className="indicator-text">
                {displayValue
                  || indicator.explanation
                  || "No description provided"}
              </div>
            </div>
          </div>

          <div className="confirm-auto-scoring-actions">
            <button onClick={dismissSuggestion} className="btn-cancel">
              Cancel
            </button>
            <Tooltip
              title={
                isAutoScoreAlreadyRecommended
                  ? "Score is already as recommended"
                  : ""
              }
              placement="top"
            >
              <span>
                <button
                  type="button"
                  onClick={
                    isAutoScoreAlreadyRecommended
                      ? undefined
                      : acceptSuggestedScore
                  }
                  className="btn-confirm"
                  disabled={isAutoScoreAlreadyRecommended}
                  aria-disabled={isAutoScoreAlreadyRecommended}
                  style={
                    isAutoScoreAlreadyRecommended
                      ? {
                        opacity: 0.6,
                        cursor: "not-allowed",
                      }
                      : undefined
                  }
                >
                  Confirm & Auto-Score
                </button>
              </span>
            </Tooltip>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default ImplementationRubricIndicator
